'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Calendar: ()=>Calendar
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const format_namespaceObject = require("date-fns/format");
const external_react_namespaceObject = require("react");
const external_react_day_picker_namespaceObject = require("react-day-picker");
const locale_namespaceObject = require("react-day-picker/locale");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const HeatMapDayButton_cjs_namespaceObject = require("../CustomComponents/HeatMapDayButton.cjs");
const MonthButtons_cjs_namespaceObject = require("../CustomComponents/MonthButtons.cjs");
const helpers_cjs_namespaceObject = require("../helpers/helpers.cjs");
const DayMapProvider_cjs_namespaceObject = require("../Providers/DayMapProvider.cjs");
const external_Calendar_variants_cjs_namespaceObject = require("./Calendar.variants.cjs");
const DEFAULT_TIMEZONE = 'America/Toronto';
function Calendar({ mode = 'single', numberOfMonths = 1, captionLayout = 'label', selected, handleCalendarChange, min, max, startMonth, endMonth, onMonthChange, className, isMobile, timeZone = DEFAULT_TIMEZONE, components: customComponents, dayMap, lowestPrice, ...restProps }) {
    const [selectedDates, setSelectedDates] = (0, external_react_namespaceObject.useState)(selected);
    const [hoveredRangeDays, setHoveredRangeDays] = (0, external_react_namespaceObject.useState)([]);
    const handleSelect = (value, triggerDate)=>{
        setSelectedDates(value);
        setHoveredRangeDays([]);
        handleCalendarChange(value, triggerDate);
    };
    const styles = (0, external_Calendar_variants_cjs_namespaceObject.calendarVariants)({
        isMobile,
        isDayMap: !!dayMap?.data
    });
    const classNames = {
        root: (0, index_cjs_namespaceObject.cn)(styles.root(), className),
        month_caption: styles.monthCaption(),
        button_previous: styles.buttonPrevious(),
        button_next: styles.buttonNext(),
        caption_label: styles.captionLabel(),
        nav: styles.nav(),
        months: styles.months(),
        month: styles.month(),
        weekdays: styles.weekdays(),
        week_row: styles.weekRow(),
        week_header: styles.weekHeader(),
        day: styles.day(),
        day_button: styles.dayButton(),
        selected: styles.selectedDays(),
        today: styles.today(),
        outside: styles.outsideDay(),
        weeks: styles.weeks(),
        week: styles.week(),
        weekday: styles.weekday(),
        week_number: styles.weekNumber(),
        chevron: styles.chevron(),
        month_grid: styles.monthGrid(),
        range_start: styles.rangeStart(),
        range_middle: styles.rangeMiddle(),
        range_end: styles.rangeEnd(),
        hovered_range_start: styles.hoveredRangeStart(),
        hovered_range_end: styles.hoveredRangeEnd(),
        disabled: styles.disabled(),
        hidden: styles.hidden()
    };
    const props = {
        mode,
        classNames,
        formatters: {
            formatWeekdayName: (weekday, options)=>(0, format_namespaceObject.format)(weekday, 'ccc', options)
        },
        min,
        max,
        numberOfMonths,
        startMonth,
        endMonth,
        locale: locale_namespaceObject.enUS,
        timeZone,
        captionLayout,
        onMonthChange,
        components: {
            NextMonthButton: MonthButtons_cjs_namespaceObject.NextMonthButton,
            PreviousMonthButton: MonthButtons_cjs_namespaceObject.PreviousMonthButton,
            DayButton: HeatMapDayButton_cjs_namespaceObject.HeatMapDayButton,
            ...customComponents
        },
        fixedWeeks: !isMobile,
        selected: selected || selectedDates,
        onSelect: handleSelect,
        hideNavigation: !!isMobile,
        modifiers: {
            hoveredRangeStart: [
                hoveredRangeDays[0]
            ],
            hoveredRange: hoveredRangeDays.slice(1, hoveredRangeDays.length - 1),
            hoveredRangeEnd: [
                hoveredRangeDays[hoveredRangeDays.length - 1]
            ]
        },
        modifiersClassNames: {
            hoveredRangeStart: styles.hoveredRangeStart(),
            hoveredRange: styles.rangeMiddle(),
            hoveredRangeEnd: styles.hoveredRangeEnd()
        },
        onDayMouseEnter: (day)=>{
            const dates = (0, helpers_cjs_namespaceObject.getHoveredDateRange)(mode, day, selectedDates);
            setHoveredRangeDays(dates);
        },
        footer: customComponents?.Footer ? 'Footer' : null,
        ...restProps
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DayMapProvider_cjs_namespaceObject.DayMapProvider, {
        dayMap: dayMap,
        mode: mode,
        lowestPrice: lowestPrice,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_day_picker_namespaceObject.DayPicker, {
            ...props
        })
    });
}
exports.Calendar = __webpack_exports__.Calendar;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Calendar"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
